import React from 'react';
import {chain, ListIcon, StatisticsIcon, StartEndIcon} from '@genestack/ui';
import {QueryRightPanelTab} from '../../../../../components/layout/page-layout/layout-typings';
import {useQueryLayoutProps} from '../../../hooks/use-query-layout-props';
import {useGlobalStateVariable} from '../../../../../providers/global-state';
import {
    VerticalBar,
    VerticalBarItem
} from '../../../../../components/layout/vertical-bar/vertical-bar';
import styles from './right-panel.module.css';

const SIDEBAR_TABS: VerticalBarItem[] = [
    {
        tooltip: 'Results as list',
        value: QueryRightPanelTab.RESULTS_LIST,
        prepend: <ListIcon />
    },
    {
        tooltip: 'Statistics',
        value: QueryRightPanelTab.STATISTICS,
        prepend: <StatisticsIcon />
    },
    {
        tooltip: 'Start and end nodes',
        value: QueryRightPanelTab.START_END_NODES,
        prepend: <StartEndIcon />
    }
];

interface Props {
    queryLayoutProps: ReturnType<typeof useQueryLayoutProps>;
}

export const RightPanelNavBar = (props: Props) => {
    const [selectedTab, setSelectedTab] = useGlobalStateVariable(
        'queries.rightPanel.selectedTab',
        QueryRightPanelTab.STATISTICS
    );

    return (
        /* use wrapper to prevent wide activity bar before results were loaded */
        <div className={styles.rightPanelNavBarContainer}>
            <VerticalBar
                tabs={SIDEBAR_TABS}
                value={props.queryLayoutProps.isQueryRightPanelOpen ? selectedTab : undefined}
                onValueChange={chain(setSelectedTab, props.queryLayoutProps.openQueryRightPanel)}
                placement="right"
            />
        </div>
    );
};
